import { css } from '@emotion/css';
import { DesignToken, RadiusToken, SpacingToken } from '@livechat/design-system-react-components';
import { ellipsis } from 'polished';

export const navigateButton = css`
  margin-right: var(${SpacingToken.Spacing1});
`;

export const bottomBarContainer = css`
  min-height: 24px;
  width: 100%;
`;

export const bottomBar = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin: var(${SpacingToken.Spacing2}) var(${SpacingToken.Spacing4}) 0 var(${SpacingToken.Spacing4});

  &:hover .tooltip {
    opacity: 1;
    visibility: visible;
  }
`;

export const sourcesList = css`
  margin: var(${SpacingToken.Spacing3}) 0 0 var(${SpacingToken.Spacing3});
`;

export const bottomBarIcons = css`
  display: flex;
`;

export const sourcesButton = css`
  background: none;
  border-radius: var(${RadiusToken[3]});
  padding: var(${SpacingToken.Spacing05}) var(${SpacingToken.Spacing2}) var(${SpacingToken.Spacing05}) 6px;

  color: var(${DesignToken.ContentBasicSecondary});

  &:hover {
    background: none;
  }
`;

export const sourcesButtonActive = css`
  color: var(${DesignToken.ContentBasicPrimary});
`;

export const button = css`
  border: none;
  background: none;
  padding: 0;
  margin: 0;

  svg {
    color: var(${DesignToken.ContentBasicSecondary});
  }

  &:hover {
    cursor: pointer;
    svg {
      color: var(${DesignToken.ContentBasicPrimary});
    }
  }
`;

export const tooltip = css`
  width: auto;
  font-size: 14px;
  text-align: center;
`;

const linkContainer = css`
  display: flex;
  align-items: center;
  margin-bottom: var(${SpacingToken.Spacing2});

  &:hover {
    cursor: pointer;
  }

  div:first-child {
    width: 100%;
  }

  span {
    color: var(${DesignToken.ContentBasicPrimary});
    width: 24px;
    height: 24px;
    padding: var(${SpacingToken.Spacing1});
    border-radius: var(${RadiusToken[1]});
    display: flex;
    margin-right: var(${SpacingToken.Spacing2});
  }
`;

export const urlLinkContainer = css`
  ${linkContainer};

  span {
    background-color: var(${DesignToken.SurfacePrimaryActiveColored});
  }
`;

export const apiCallLinkContainer = css`
  ${linkContainer};

  span {
    background-color: var(${DesignToken.SurfaceTertiaryDefault});
  }
`;

export const pdfLinkContainer = css`
  ${linkContainer};

  span {
    background-color: var(${DesignToken.DecorRed300});
  }
`;

export const tooltipSourceLink = css`
  font-size: 13px;
  font-weight: 400;
`;

export const defaultCursor = css`
  &:hover {
    cursor: default;
  }

  &:active,
  &:focus {
    box-shadow: none;
  }
`;

export const urlSourceName = css`
  display: flex;
  align-items: center;
  max-width: 300px;
`;

export const sourceMaxWidth = css`
  max-width: 712px;
`;

export const sourceItem = css`
  color: var(${DesignToken.ContentBasicPrimary});
  font-size: 13px;
  font-weight: 400;
  text-decoration-line: underline;
  line-height: 22px;
  ${ellipsis()}
  cursor: pointer;
`;

export const openInNewIcon = css`
  background-color: unset !important;
  margin: 0 0 var(${SpacingToken.Spacing1}) var(${SpacingToken.Spacing2}) !important;
  width: 20px !important;
  height: 20px !important;
  padding: 0 !important;
`;

export const sourcesContainer = css`
  display: flex;
  margin-top: var(${SpacingToken.Spacing1});
  justify-content: center;
  align-items: center;
`;

export const sourcesBadgeActive = css`
  color: var(${DesignToken.ContentBasicPrimary});
`;
